import { useContext, useEffect, useState } from 'react'
import { LayoutContext } from './Layout'
import { Box, GridItem, Hide, IconButton, Show } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { MobilePanel } from './MobilePanel'

export const RightPanel = ({
  children,
  closeButtonProps,
  showOverlay,
  ...rest
}) => {
  const { isRightPanelOpen, onToggleRightPanel, setShowOverlay } =
    useContext(LayoutContext)
  const [waitCloseAnimation, setWaitCloseAnimation] = useState(false)
  useEffect(() => {
    let timeout
    if (!isRightPanelOpen) {
      timeout = setTimeout(() => {
        setWaitCloseAnimation(false)
      }, 300)
    } else {
      setWaitCloseAnimation(true)
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [isRightPanelOpen])
  useEffect(() => {
    setShowOverlay(showOverlay)
  }, [setShowOverlay, showOverlay])

  return (
    <>
      <Show above="xl">
        <GridItem
          zIndex="2001"
          {...rest}
          h="100vh"
          position="relative"
          backgroundColor="brand.white"
          boxShadow="0 2px 4px 0 rgba(0,0,0,0.1)"
          className="right-panel"
        >
          <IconButton
            boxShadow="0 2px 4px 0 rgba(0,0,0,0.1)"
            backgroundColor="white"
            left="-17px"
            top="28px"
            borderRadius="100%"
            icon={
              <ChevronRightIcon
                w="28px"
                height="20px"
              />
            }
            onClick={() => onToggleRightPanel(!isRightPanelOpen)}
            position="absolute"
            aria-label="Close"
            zIndex="2002"
            minWidth="34px"
            width="34px"
            height="34px"
            {...closeButtonProps}
            display={waitCloseAnimation ? 'flex' : 'none'}
            _active={{
              backgroundColor: 'white',
            }}
          />
          <Box
            position="relative"
            overflow="hidden"
            w="100%"
            h="100vh"
          >
            {children}
          </Box>
        </GridItem>
      </Show>
      <Hide above="xl">
        <MobilePanel className="right-panel">{children}</MobilePanel>
      </Hide>
    </>
  )
}
